import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';
import Switch from '@mui/material/Switch';
import AllInclusive from '@mui/icons-material/AllInclusive';
import React from 'react';
import SignalRConnector, { signalRDetail } from 'src/coreservices/SignalRConnector';
import { InformationModal } from 'src/formcontrols/Modals/InformationModal/InformationModal';
import { writeAIEvent } from 'src/utils/AppInsight';
import { GetLocalStateProfile } from 'src/comps/UserProfile/UserProfile';

const useStyles = makeStyles()((theme: any) => ({
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(14px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {},
  iOSBar: {
    borderRadius: 13,
    width: 32,
    height: 18,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 14,
    height: 14,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
}));
let useSignalR: boolean;
let onDemandSignalR = false;
interface ISignalRProps {
  switched: boolean;
  position: string;
  classes?: any;
  isOpenSignalRDetail?: boolean;
  onDemandSignalR?: boolean;
  updateUseSignalR?: any;
  onSaveUseSignalR?: any;
}

interface ISignalRState {
  switched: boolean;
  isOpenSignalRDetail: boolean;
}
const divStyle = {
  height: '30px',
};
class UseSignalR extends React.Component<ISignalRProps, ISignalRState> {
  constructor(props: any) {
    super(props);
    this.state = {
      switched: this.props.switched,
      isOpenSignalRDetail: false,
    };
    this.openSignalRDetail = this.openSignalRDetail.bind(this);
    this.closeSignalRDetail = this.closeSignalRDetail.bind(this);
  }

  componentDidMount() {
    const userProfile = GetLocalStateProfile();
    if (!onDemandSignalR) {
      if (userProfile.DefaultUseSignalR) {
        this.setState({ switched: true });
        useSignalR = true;
      } else {
        this.setState({ switched: false });
        useSignalR = false;
      }
    }
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({ isOpenSignalRDetail: nextProps.isOpenSignalRDetail });
    const userProfile = GetLocalStateProfile();
    if (nextProps.onSaveUseSignalR) {
      onDemandSignalR = false;
      this.props.updateUseSignalR();
    }
    if (!onDemandSignalR) {
      if (userProfile.DefaultUseSignalR) {
        this.setState({ switched: true });
        useSignalR = true;
      } else {
        this.setState({ switched: false });
        useSignalR = false;
      }
    }
  }

  handleChange = (_name: any) => async (event: any) => {
    onDemandSignalR = true;
    this.setState({ switched: event.target.checked });
    useSignalR = event.target.checked;
    const signalRConnector = new SignalRConnector({ isUseSignalR: false });
    if (useSignalR) {
      writeAIEvent(`Use SignalR - True`);
      await signalRConnector.connectToSignalR();
    } else {
      writeAIEvent(`Use SignalR - False`);
      signalRConnector.disconnectSignalR();
    }
    signalRConnector.updateUseSignalR(useSignalR);
    const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
    if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
      imgSignalR[0].style.display = useSignalR ? 'none' : 'none';
    }
  };
  openSignalRDetail() {
    this.setState({ isOpenSignalRDetail: true });
  }
  closeSignalRDetail() {
    this.setState({ isOpenSignalRDetail: false });
  }

  render() {
    const { classes } = this.props;

    return this.props.position === 'app' ? (
      <div style={{ marginTop: '5px' }}>
        <InformationModal
          isLoading={false}
          isModalOpen={this.state.isOpenSignalRDetail}
          modalHeader="SignalR Connection Information"
          onCloseModal={this.closeSignalRDetail}
        >
          <table>
            <tbody>
              <div style={divStyle}>SignalR Client Id : {signalRDetail ? signalRDetail.SignalrClientId : ''} </div>
              <div style={divStyle}>Transport Type : {signalRDetail ? signalRDetail.TransportType : ''} </div>
              <div style={divStyle}>Elapsed Time : {signalRDetail ? signalRDetail.ElapsedTime : ''} </div>
              <div style={divStyle}>SignalR Status : {signalRDetail ? 'Connected' : 'Disconnected'} </div>
            </tbody>
          </table>
        </InformationModal>
        <Tooltip title="Connected">
          <AllInclusive onClick={this.openSignalRDetail} className="signalRClass" style={{ display: 'none' }} />
        </Tooltip>
      </div>
    ) : (
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: '16px' }}
      >
        <span>Use SignalR</span>
        <Switch
          sx={{ width: 36, height: 22, padding: 0 }}
          classes={{
            switchBase: classes.iOSSwitchBase,
            track: classes.iOSBar,
            thumb: classes.iOSIcon,
          }}
          disableRipple
          checked={useSignalR}
          onChange={this.handleChange('checkedB')}
          value="checkedB"
        />
      </div>
    );
  }
}

const UseSignalRWithStyles = (props: Omit<ISignalRProps, 'classes'>) => {
  const { classes } = useStyles();
  return <UseSignalR {...props} classes={classes} />;
};

export default UseSignalRWithStyles;
export { useSignalR };
